import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDde7XXCiZQowDvtND66PshzME3aM7bA5E",
  authDomain: "indiahiring-2bc5d.firebaseapp.com",
  projectId: "indiahiring-2bc5d",
  storageBucket: "indiahiring-2bc5d.firebasestorage.app",
  messagingSenderId: "1022207017822",
  appId: "1:1022207017822:web:6920142fda49fe2917c5cf",
  measurementId: "G-8VSWH3WS96"
};


// Initialize Firebase 
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

const setupRecaptcha = () => {
  window.recaptchaVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
    size: "invisible",
    callback: (response) => {
      console.log("Recaptcha Verified!");
    },
  });
};

export { auth, googleProvider, setupRecaptcha, RecaptchaVerifier, signInWithPhoneNumber };
